
<template>
  <!--批量分配钥匙-->
  <x-addEdit
    ref="addEdit"
    :formList="formList"
    :addParam="addParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'batchAllocation',
  data () {
    let decoratorOptions = {
      communityId: {
        rules: [{ required: true, message: '请选择小区' }]
      },
      positionId: {
        rules: [{ required: true, message: '请选择位置' }]
      },
      deviceId: {
        rules: [{ required: true, message: '请选择设备' }]
      }
    };
    return {
      formList: [
        {
          label: '小区',
          inputType: 'select',
          options: [],
          placeholder: '请选择小区',
          handle: ($event) => {
            this.communityChange_getPosi(1, $event, 'formList');

            this.$refs.addEdit.form.resetFields(['positionId', 'deviceId']);
            this.formList[2].options = [];
          },
          fetchOptions: this.getOptions,
          props: ['communityId', decoratorOptions.communityId]
        },
        {
          label: '位置',
          inputType: 'select',
          options: [],
          placeholder: '请选择位置',
          handle: ($event) => {
            this.positionChange(2, $event, 'formList');

            this.$refs.addEdit.form.resetFields(['deviceId']);
          },
          props: ['positionId', decoratorOptions.positionId]
        },
        {
          label: '可选设备',
          inputType: 'select',
          options: [],
          placeholder: '请选择设备',
          props: ['deviceId', decoratorOptions.deviceId]
        }
      ],
      addParam: {
        url: '/passKey/batchAssign',
        reqHandle: undefined,
        resHandle: this.addResHandle
      }
    };
  },
  mounted () {
    // this.communitySelect(0, 'formList', '1');
    this.communitySelectByStep(1, undefined, undefined, '0');
  },
  methods: {
    getOptions (pageNum, search, item) {
      return this.communitySelectByStep(pageNum, search, undefined, '0', item.communityId);
    },
    addResHandle ({ data }) {
      this.$message.success(`成功分配 ${data}把 钥匙`);
      this.$router.go(-1);
    }
  }
};
</script>
